import { customFieldsForModel } from './customFieldsForModel';
import { getInComplianceReportingPeriodSetting } from './getInComplianceReportingPeriodSetting';
import { getResourcesCategories } from './getResourcesCategories';
import { getTicketGiveawayHtml } from './getTicketGiveawayHtml';

export const configAPI = {
  customFieldsForModel,
  getInComplianceReportingPeriodSetting,
  getResourcesCategories,
  getTicketGiveawayHtml,
};
